import type { JSX } from 'react';
import type { Me } from '../auth/use-me';
import { failureFrom } from '@/lib/result';
import { ErrorState } from '../shell/states';
import { Hero } from './hero';
import { LiveActivity } from './live-activity';
import { SourceHealthCard } from './source-health-card';
import { StatTiles } from './stat-tiles';
import { useOverview } from './use-overview';

/** The landing screen (design L302–360): status, the numbers, what just happened. */
export function OverviewPage({ me }: { me: Me }): JSX.Element {
  const overview = useOverview();
  return (
    <section className="animate-[rise_.5s_ease_both] grid grid-cols-1 items-start gap-7 desk:grid-cols-[minmax(0,1.1fr)_minmax(0,1fr)]">
      {overview.isPending && <HeroSkeleton />}
      {overview.isError && (
        <ErrorState
          className="col-span-full"
          {...failureFrom(overview.error)}
          onRetry={() => void overview.refetch()}
        />
      )}
      {overview.data !== undefined && (
        <>
          <Hero overview={overview.data} me={me} />
          <StatTiles overview={overview.data} />
        </>
      )}
      <LiveActivity />
      <SourceHealthCard />
    </section>
  );
}

function HeroSkeleton(): JSX.Element {
  return (
    <div className="col-span-full flex flex-col gap-3.5" aria-busy="true">
      <div className="skeleton h-[222px] rounded-[20px]" />
      <div className="grid grid-cols-2 gap-3.5 desk:grid-cols-4">
        {[0, 1, 2, 3].map((i) => (
          <div key={i} className="skeleton h-[92px] rounded-[14px]" />
        ))}
      </div>
    </div>
  );
}
